import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import moment from 'moment';
import { Heading, Paragraph, PlainCard, ProgressPie, Skeleton } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

export default Skeleton(
	function TalentReviewCard(props: { talentReview: graphql.TalentReview; userID: string }) {
		const { t } = useTranslation();

		const progress = !Number.isNaN(
			props.talentReview.placements.length / props.talentReview.group.members.totalCount,
		)
			? props.talentReview.placements.length / props.talentReview.group.members.totalCount
			: 0;

		return (
			<PlainCard to={`/talent-reviews/${props.talentReview.id}`}>
				<Flex alignItems="center">
					<Box py={3} flexGrow={1} flexShrink={1}>
						<Paragraph>
							{t('talent-reviews.index.card.createdAt', {
								date: moment(props.talentReview.createdAt).format('LL'),
							})}
							{' · '}
							{t('talent-reviews.index.card.progress', {
								placed: props.talentReview.placements.length,
								total: props.talentReview.group.members.totalCount,
							})}
						</Paragraph>
						<Heading mt={2}>{props.talentReview.title}</Heading>
					</Box>

					<Box>
						<ProgressPie progress={progress} />
					</Box>
				</Flex>
			</PlainCard>
		);
	},
	function TalentReviewSkeleton() {
		return (
			<PlainCard.Skeleton>
				<Flex alignItems="center">
					<Box py={3} flexGrow={1} flexShrink={1}>
						<Paragraph.Skeleton lines={1} />
						<Heading.Skeleton mt={2} />
					</Box>
					<Box>
						<ProgressPie.Skeleton />
					</Box>
				</Flex>
			</PlainCard.Skeleton>
		);
	},
);
